<template>
  <v-app>
    <!-- <v-navigation-drawer
      app
      :value="show_menu"
      color="#fff"
      width="200"
      height="100vh"
      :mini-variant.sync="mini"
      dark
      class="list-menu"
      @input="handleChangeViewMenu"
      @change="handleChangeViewMenuChange"
    >
      <v-list-item style="background-color: #fff">
        <v-list-item-content>
          <v-list-item-title>

            <img src="img/tomolab-logo.png" width="150" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list>
        
        <v-list-item
          v-if="verConfiguracion()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_configuracion"
                  >
                    <i class="bx bx-cog bx-sm"></i>
                    <label class="text-menu" for="">Configuración</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('sucursales')"
                    router
                    to="/app/configuracion/sucursales"
                  >
                    <v-list-item-title>Sucursales</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="this.$hasMenu('comprobantes')"
                    router
                    to="/app/configuracion/comprobantes"
                  >
                    <v-list-item-title>Comprobantes</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('cuentas-bancarias')"
                    router
                    to="/app/configuracion/cuentas-bancarias"
                  >
                    <v-list-item-title>Cuentas Bancarias</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-title>

          </v-list-item-group>
        </v-list-item>

        <v-list-item
          v-if="verRegistros()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_registros"
                  >
               
                    <i class="bx bx-list-ul bx-sm"></i>
                    <label for="" class="text-menu">Registros</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('categorias')"
                    router
                    to="/app/registros/categorias"
                  >
                    <v-list-item-title>Categorias</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('marcas')"
                    router
                    to="/app/registros/marcas"
                  >
                    <v-list-item-title>Marcas</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="this.$hasMenu('unidades')"
                    router
                    to="/app/registros/unidades"
                  >
                    <v-list-item-title>Unidades de medida</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-title>

          </v-list-item-group>
        </v-list-item>

        <v-list-item
          v-if="verLogistica()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_logistica"
                  >
                    <i class="bx bx-car bx-sm"></i>
                    <label for="" class="text-menu">Logistica</label>

                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('proveedores')"
                    router
                    to="/app/logistica/proveedores"
                  >
                    <v-list-item-title>Proveedores</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="this.$hasMenu('compras')"
                    router
                    to="/app/logistica/compras"
                    @click="selectPurchase"
                  >
                    <v-list-item-title>Compras</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('almacenes')"
                    router
                    to="/app/logistica/almacenes"
                  >
                    <v-list-item-title>Almacenes Materiales</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('almacenesReactivos')"
                    router
                    to="/app/logistica/almacenesReactivos"
                  >
                    <v-list-item-title>Almacenes reactivos</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('transferencias')"
                    router
                    to="/app/logistica/transferencias"
                  >
                    <v-list-item-title>Transferencias </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-title>

          </v-list-item-group>
        </v-list-item>

        <v-list-item
          v-if="verNewLab()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_laboratorio"
                  >
                    <i class="bx bx-injection bx-sm"></i>
                    <label for="" class="text-menu">Laboratorio</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('especialidad')"
                    router
                    to="/app/laboratorio/especialidad"
                  >
                    <v-list-item-title>Especialidad</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('material')"
                    router
                    to="/app/laboratorio/material"
                  >
                    <v-list-item-title>Materiales</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('reactivos')"
                    router
                    to="/app/laboratorio/reactive"
                  >
                    <v-list-item-title>Reactivos</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('analisis')"
                    router
                    to="/app/laboratorio/analisis"
                  >
                    <v-list-item-title>Analisis</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('procesamiento')"
                    router
                    to="/app/laboratorio/procesamiento"
                  >
                    <v-list-item-title>Procesamiento</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('report')"
                    router
                    to="/app/laboratorio/report"
                  >
                    <v-list-item-title>Informar</v-list-item-title>
                  </v-list-item>

                 
                </v-list>
              </v-menu>
            </v-list-item-title>

          </v-list-item-group>
        </v-list-item>

        <v-list-item
          v-if="verTesoreria()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_tesoreria"
                  >
                    <i class="bx bx-package bx-sm"> </i>
                    <label for="" class="text-menu">Tesoreria</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('comision-medicos')"
                    router
                    to="/app/tesoreria/comisionMedicos"
                  >
                    <v-list-item-title>Comisiones médicos</v-list-item-title>
                  </v-list-item>
                  
                </v-list>
              </v-menu>
            </v-list-item-title>
           
          </v-list-item-group>
        </v-list-item>

        

        <v-list-item
          v-if="verVentas()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_ventas"
                  >
                   
                    <i class="bx bx-cart bx-sm"></i>
                    <label for="" class="text-menu">Ventas</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('clientes')"
                    router
                    to="/app/ventas/clientes"
                  >
                    <v-list-item-title>Clientes</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('pacientes')"
                    router
                    to="/app/ventas/pacientes"
                  >
                    <v-list-item-title>Pacientes</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('doctores')"
                    router
                    to="/app/ventas/doctores"
                  >
                    <v-list-item-title>Médicos</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="this.$hasMenu('companies')"
                    router
                    to="/app/configuracion/empresas"
                  >
                    <v-list-item-title>Empresas</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="this.$hasMenu('solicitud-analisis')"
                    router
                    to="/app/atencion/solicitud-analisis"
                  >
                    <v-list-item-title>Solicitud de análisis</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="this.$hasMenu('cotizaciones')"
                    router
                    to="/app/ventas/cotizaciones"
                  >
                    <v-list-item-title>Cotizaciones</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-title>
            
          </v-list-item-group>
        </v-list-item>

        

        <v-list-item
          v-if="verCuentas()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_cuentas"
                  >
                 
                    <i class="bx bx-data bx-sm"></i>
                    <label for="" class="text-menu">Cuentas</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('cuentas-cobrar')"
                    router
                    to="/app/cuentas/cuentas-por-cobrar"
                  >
                    <v-list-item-title>Cuentas por cobrar</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('cuentas-pagar')"
                    router
                    to="/app/cuentas/cuentas-por-pagar"
                  >
                    <v-list-item-title>Cuentas por pagar</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-title>
            
          </v-list-item-group>
        </v-list-item>

        <v-list-item v-if="verCaja()" active-class="border" class="w-item-menu">
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_caja"
                  >
                    
                    <i class="bx bx-cart-download bx-sm"></i>
                    <label for="" class="text-menu">Caja</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('cajas')"
                    router
                    to="/app/cajas/cajas-registradoras"
                  >
                    <v-list-item-title>Cajas Registradas</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('movimientos')"
                    router
                    to="/app/cajas/movimientos"
                  >
                    <v-list-item-title>Movimientos</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-title>
            
          </v-list-item-group>
        </v-list-item>

        

        <v-list-item
          v-if="verPlanilla()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_planilla"
                  >
                    
                    <i class="bx bx-spreadsheet bx-sm"></i>
                    <label for="" class="text-menu">Planilla</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('recibos-honorarios')"
                    router
                    to="/app/planillas/Honorarios"
                  >
                    <v-list-item-title>Recibo por Honorarios</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('planillas')"
                    router
                    to="/app/planillas/planillas-Info"
                  >
                    <v-list-item-title>Planillas</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('bonos')"
                    router
                    to="/app/planillas/bonos"
                  >
                    <v-list-item-title>Bonos</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('regimenes')"
                    router
                    to="/app/planillas/Regimen"
                  >
                    <v-list-item-title>Régimen de Pensiones</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('seguros')"
                    router
                    to="/app/planillas/Seguros"
                  >
                    <v-list-item-title>Sistema de Salud</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('puestos')"
                    router
                    to="/app/planillas/Puestos"
                  >
                    <v-list-item-title>Puestos</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-title>
          </v-list-item-group>
        </v-list-item>

        <v-list-item
          v-if="verSeguridad()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_seguridad"
                  >
                    
                    <i class="bx bx-shield-alt-2 bx-sm"></i>
                    <label for="" class="text-menu">Seguridad</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('empleados')"
                    router
                    to="/app/seguridad/empleados"
                  >
                    <v-list-item-title>Empleados</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('roles')"
                    router
                    to="/app/seguridad/roles"
                  >
                    <v-list-item-title>Roles de usuarios</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-title>
   
          </v-list-item-group>
        </v-list-item>

        <v-list-item
          v-if="verReportes()"
          active-class="border"
          class="w-item-menu"
        >
          <v-list-item-group
            style="display: flex; align-items: center; padding-left: 18px"
          >
            <v-list-item-title>
              <v-menu
                offset-x
                :open-on-hover="true"
                transition="slide-x-transition"
                nudge-right="22"
                dark
                min-width="150"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    class="btn-navbar btn-active"
                    id="id_reporte"
                  >
                    <i class="bx bx-receipt bx-sm"></i>
                    <label for="" class="text-menu">Reportes</label>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="this.$hasMenu('reporte-compras')"
                    router
                    to="/app/reportes/reporte-compras"
                  >
                    <v-list-item-title>Compras</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('reporte-ventas')"
                    router
                    to="/app/reportes/reporte-ventas"
                  >
                    <v-list-item-title>Ventas</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('reporte-ventas')"
                    router
                    to="/app/reportes/reporte-ventas-tarjeta"
                  >
                    <v-list-item-title>Ventas con tarjeta</v-list-item-title>
                  </v-list-item>
            
                  <v-list-item
                    v-if="this.$hasMenu('reporte-historial-cajas')"
                    router
                    to="/app/reportes/reporte-caja"
                  >
                    <v-list-item-title>Historial de cajas</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('reporte-transferencias')"
                    router
                    to="/app/reportes/reporte-transferencias"
                  >
                    <v-list-item-title>Transferencias</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('reporte-consumo-interno')"
                    router
                    to="/app/reportes/consumo-interno"
                  >
                    <v-list-item-title>Consumo Interno</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('reporte-merma')"
                    router
                    to="/app/reportes/merma"
                  >
                    <v-list-item-title>Merma</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('reporte-productos-vendidos')"
                    router
                    to="/app/reportes/productos-vendidos"
                  >
                    <v-list-item-title>Productos Vendidos</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="this.$hasMenu('reporte-servicios-atendidos')"
                    router
                    to="/app/reportes/servicios-atendidos"
                  >
                    <v-list-item-title>Servicios Atendidos</v-list-item-title>
                  </v-list-item>
               
                </v-list>
              </v-menu>
            </v-list-item-title>
            
          </v-list-item-group>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-around;
            padding: 4px 10px 14px 10px;
          "
        >
          <v-btn fab dark small color="red" @click="handleLogout">
            <v-icon size="16">fas fa-sign-out-alt</v-icon>
          </v-btn>
          <v-btn
            v-if="locked"
            fab
            dark
            small
            color="green"
            @click="handleUnLockSystem"
          >
            <v-icon size="16">fas fa-lock-open</v-icon>
          </v-btn>
          <v-btn v-else fab dark small color="amber" @click="handleLockSystem">
            <v-icon size="16">fas fa-lock</v-icon>
          </v-btn>
          <v-btn
            v-if="user_offices.length > 1"
            fab
            dark
            small
            color="blue"
            @click="handleChangeOfficeLogin"
          >
            <v-icon size="16">fas fa-exchange-alt</v-icon>
          </v-btn>
         
        </div>
      </template>
    </v-navigation-drawer> -->

    <v-navigation-drawer
      app
      :value="show_menu"
      color="#fff"
      width="212"
      height="100vh"
      class="list-menu"
      @input="handleChangeViewMenu"
    >
      <!-- :mini-variant.sync="mini"
      permanent -->
      <v-list nav dense>
        <v-list-item>
          <v-list-item-content to="/">
            <v-list-item-title>
              <img src="img/tomolab-logo.png" width="120" />
            </v-list-item-title>
          </v-list-item-content>
          <!-- <v-list-item-content>
            <v-list-item-title to="/">
              <img src="img/tomolab-logo.png" width="120" />
            </v-list-item-title>
          </v-list-item-content>
          <v-btn icon @click.stop="mini = !mini">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn> -->
        </v-list-item>

        <v-list-group
          :value="false"
          v-if="verDashboard()"
          no-action
          color="green"
        >
          <template v-slot:activator>
            <i
              class="bx bxs-dashboard bx-sm icon-color"
              id="id_dashboard_icon"
            ></i>
            <label for="" class="text-menu" id="id_dashboard_text"
              >Dashboard</label
            >
            <!-- <v-list-item-title style="">Configuración</v-list-item-title> -->
          </template>

          <v-list-item
            v-if="this.$hasMenu('dashboard-analisis')"
            router
            to="/app/dashboard-analisys"
            class="items-menu"
          >
            <i
              class="bx bx-search-alt bx-sm icon-menu icon-color"
              id="id_analisis_icon"
            ></i>
            <v-list-item-title>Análisis</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('dashboard-medico')"
            router
            to="/app/dashboard-doctor"
            class="items-menu"
          >
            <i
              class="bx bx-user bx-sm icon-menu icon-color"
              id="id_doctores_icon"
            ></i>
            <v-list-item-title>Médicos</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('dashboard-paciente')"
            router
            to="/app/dashboard-paciente"
            class="items-menu"
          >
            <i
              class="bx bx-user bx-sm icon-menu icon-color"
              id="id_doctores_icon"
            ></i>
            <v-list-item-title>Pacientes</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('dashboard-convenio')"
            router
            to="/app/dashboard-convenio"
            class="items-menu"
          >
            <i
              class="bx bx-star bx-sm icon-menu icon-color"
              id="id_cuentas_bancarias_icon"
            ></i>
            <v-list-item-title>Convenio</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('dashboard-sales')"
            router
            to="/app/dashboard-ventas"
            class="items-menu"
          >
            <i
              class="bx bx-layer-plus bx-sm icon-menu icon-color"
              id="id_solicitud_analisis_icon"
            ></i>
            <v-list-item-title>Ventas</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item
            router
            to="/app/dashboard-ventas-promocional"
            class="items-menu"
          >
            <i
              class="bx bx-star bx-sm icon-menu icon-color"
              id="id_cuentas_bancarias_icon"
            ></i>
            <v-list-item-title>Ventas Promocional</v-list-item-title>
          </v-list-item>
          <v-list-item
            router
            to="/app/dashboard-orden-atencion"
            class="items-menu"
          >
            <i
              class="bx bx-star bx-sm icon-menu icon-color"
              id="id_cuentas_bancarias_icon"
            ></i>
            <v-list-item-title>Orden de Servicio</v-list-item-title>
          </v-list-item> -->
        </v-list-group>

        <v-list-group
          :value="false"
          no-action
          v-if="verConfiguracion()"
          color="green"
        >
          <template v-slot:activator>
            <i
              class="bx bx-cog bx-sm icon-color"
              id="id_configuracion_icon"
            ></i>
            <label for="" class="text-menu" id="id_configuracion_text"
              >Configuración</label
            >
            <!-- <v-list-item-title style="">Configuración</v-list-item-title> -->
          </template>

          <v-list-item
            v-if="this.$hasMenu('sucursales')"
            router
            to="/app/configuracion/sucursales"
            class="items-menu"
          >
            <i
              class="bx bx-building-house bx-sm icon-menu icon-color"
              id="id_sucursales_icon"
            ></i>
            <v-list-item-title>Sucursales</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('comprobantes')"
            router
            to="/app/configuracion/comprobantes"
            class="items-menu"
          >
            <i
              class="bx bx-detail bx-sm icon-menu icon-color"
              id="id_comprobantes_icon"
            ></i>
            <v-list-item-title>Comprobantes</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('cuentas-bancarias')"
            router
            to="/app/configuracion/cuentas-bancarias"
            class="items-menu"
          >
            <i
              class="bx bx-data bx-sm icon-menu icon-color"
              id="id_cuentas_bancarias_icon"
            ></i>
            <v-list-item-title>Cuentas Bancarias</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          :value="false"
          no-action
          v-if="verRegistros()"
          color="green"
        >
          <template v-slot:activator style="width: 100% !important">
            <i
              class="bx bx-list-ul bx-sm icon-color"
              id="id_registros_icon"
            ></i>
            <label for="" class="text-menu" id="id_registros_text"
              >Registros</label
            >
            <!-- <v-list-item-title>Registros</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('categorias')"
            router
            to="/app/registros/categorias"
            class="items-menu"
          >
            <i
              class="bx bx-customize bx-sm icon-menu icon-color"
              id="id_categorias_icon"
            ></i>
            <v-list-item-title>Categorias</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('marcas')"
            router
            to="/app/registros/marcas"
            class="items-menu"
          >
            <i
              class="bx bx-purchase-tag-alt bx-sm icon-menu icon-color"
              id="id_marcas_icon"
            ></i>
            <v-list-item-title>Marcas</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('unidades')"
            router
            to="/app/registros/unidades"
            class="items-menu"
          >
            <i
              class="bx bx-ruler bx-sm icon-menu icon-color"
              id="id_unidades_icon"
            ></i>
            <v-list-item-title>Unidades de medida</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('zonas')"
            router
            to="/app/registros/zonas"
            class="items-menu"
          >
            <i
              class="bx bx-git-repo-forked bx-sm icon-menu icon-color"
              id="id_zonas_icon"
            ></i>
            <v-list-item-title>Zonas</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('specialty')"
            router
            to="/app/registros/specialty"
            class="items-menu"
          >
            <i
              class="bx bx-git-repo-forked bx-sm icon-menu icon-color"
              id="id_zonas_icon"
            ></i>
            <v-list-item-title>Esp. Medicos</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          :value="false"
          no-action
          v-if="verLogistica()"
          color="green"
        >
          <template v-slot:activator>
            <i class="bx bx-car bx-sm icon-color" id="id_logistica_icon"></i>
            <label for="" class="text-menu" id="id_logistica_text"
              >Logística</label
            >
            <!-- <v-list-item-title>Logística</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('proveedores')"
            router
            to="/app/logistica/proveedores"
            class="items-menu"
          >
            <i
              class="bx bx-vector bx-sm icon-menu icon-color"
              id="id_proveedores_icon"
            ></i>
            <v-list-item-title>Proveedores</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('compras')"
            router
            to="/app/logistica/compras"
            class="items-menu"
            @click="selectPurchase"
          >
            <i
              class="bx bx-shopping-bag bx-sm icon-menu icon-color"
              id="id_compras_icon"
            ></i>
            <v-list-item-title>Compras</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('almacenes')"
            router
            to="/app/logistica/almacenes"
            class="items-menu"
          >
            <i
              class="bx bx-capsule bx-sm icon-menu icon-color"
              id="id_almacenes_icon"
            ></i>
            <v-list-item-title>Almacenes Materiales</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('almacenesReactivos')"
            router
            to="/app/logistica/almacenesReactivos"
            class="items-menu"
          >
            <i
              class="bx bx-vial bx-sm icon-menu icon-color"
              id="id_almacenesReactivos_icon"
            ></i>
            <v-list-item-title>Almacenes reactivos</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('transferencias')"
            router
            to="/app/logistica/transferencias"
            class="items-menu"
          >
            <i
              class="bx bx-send bx-sm icon-menu icon-color"
              id="id_transferencias_icon"
            ></i>
            <v-list-item-title>Transferencias </v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="false" no-action v-if="verNewLab()" color="green">
          <template v-slot:activator>
            <i
              class="bx bx-injection bx-sm icon-color"
              id="id_laboratorio_icon"
            ></i>
            <label for="" class="text-menu" id="id_laboratorio_text"
              >Laboratorio</label
            >
            <!-- <v-list-item-title>Laboratorio</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('especialidad')"
            router
            to="/app/laboratorio/especialidad"
            class="items-menu"
          >
            <i
              class="bx bx-medal bx-sm icon-menu icon-color"
              id="id_especialidad_icon"
            ></i>
            <v-list-item-title>Especialidad</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('material')"
            router
            to="/app/laboratorio/material"
            class="items-menu"
          >
            <i
              class="bx bx-capsule bx-sm icon-menu icon-color"
              id="id_material_icon"
            ></i>
            <v-list-item-title>Materiales</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('reactivos')"
            router
            to="/app/laboratorio/reactive"
            class="items-menu"
          >
            <i
              class="bx bx-vial bx-sm icon-menu icon-color"
              id="id_reactive_icon"
            ></i>
            <v-list-item-title>Reactivos</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('analisis')"
            router
            to="/app/laboratorio/analisis"
            class="items-menu"
          >
            <i
              class="bx bx-search-alt bx-sm icon-menu icon-color"
              id="id_analisis_icon"
            ></i>
            <v-list-item-title>Analisis</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('procesamiento')"
            router
            to="/app/laboratorio/procesamiento"
            class="items-menu"
          >
            <i
              class="bx bx-shape-polygon bx-sm icon-menu icon-color"
              id="id_procesamiento_icon"
            ></i>
            <v-list-item-title>Procesamiento</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('laboratorio-informar')"
            router
            to="/app/laboratorio/report"
            class="items-menu"
          >
            <i
              class="bx bx-edit-alt bx-sm icon-menu icon-color"
              id="id_report_informar_icon"
            ></i>
            <v-list-item-title>Informar</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          :value="false"
          no-action
          v-if="verTesoreria()"
          color="green"
        >
          <template v-slot:activator>
            <i class="bx bx-package bx-sm icon-color" id="id_tesoreria_icon">
            </i>
            <label for="" class="text-menu" id="id_tesoreria_text"
              >Tesoreria</label
            >
            <!-- <v-list-item-title>Tesoreria</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('comisiones-medicos')"
            router
            to="/app/tesoreria/comisionMedicos"
            class="items-menu"
          >
            <i
              class="bx bx-dollar bx-sm icon-menu icon-color"
              id="id_comisionMedicos_icon"
            ></i>
            <v-list-item-title>Comisiones médicos</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="false" no-action v-if="verVentas()" color="green">
          <template v-slot:activator>
            <i class="bx bx-cart bx-sm icon-color" id="id_ventas_icon"></i>
            <label for="" class="text-menu" id="id_ventas_text">Ventas</label>
            <!-- <v-list-item-title>Ventas</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('clientes')"
            router
            to="/app/ventas/clientes"
            class="items-menu"
          >
            <i
              class="bx bx-user bx-sm icon-menu icon-color"
              id="id_clientes_icon"
            ></i>
            <v-list-item-title>Clientes</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('pacientes')"
            router
            to="/app/ventas/pacientes"
            class="items-menu"
          >
            <i
              class="bx bx-user bx-sm icon-menu icon-color"
              id="id_pacientes_icon"
            ></i>
            <v-list-item-title>Pacientes</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('doctores')"
            router
            to="/app/ventas/doctores"
            class="items-menu"
          >
            <i
              class="bx bx-user bx-sm icon-menu icon-color"
              id="id_doctores_icon"
            ></i>
            <v-list-item-title>Médicos</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('companies')"
            router
            to="/app/configuracion/empresas"
            class="items-menu"
          >
            <i
              class="bx bx-buildings bx-sm icon-menu icon-color"
              id="id_empresas_icon"
            ></i>
            <v-list-item-title>Empresas</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('solicitud-venta')"
            router
            to="/app/atencion/solicitud-venta"
            class="items-menu"
          >
            <i
              class="bx bx-layer-plus bx-sm icon-menu icon-color"
              id="id_venta_icon"
            ></i>
            <v-list-item-title>Orden de servicio </v-list-item-title>
          </v-list-item>

          <!-- <v-list-item
            v-if="this.$hasMenu('solicitud-analisis')"
            router
            to="/app/atencion/solicitud-analisis"
            class="items-menu"
          > -->
          <v-list-item
            v-if="this.$hasMenu('solicitud-analisys')"
            router
            to="/app/atencion/datos-solicitud"
            class="items-menu"
          >
            <i
              class="bx bx-layer-plus bx-sm icon-menu icon-color"
              id="id_solicitud_analisis_icon"
            ></i>
            <!-- <v-list-item-title>Solicitud de análisis</v-list-item-title> -->
            <v-list-item-title>Venta</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('cotizaciones')"
            router
            to="/app/ventas/cotizaciones"
            class="items-menu"
          >
            <i
              class="bx bx-layer bx-sm icon-menu icon-color"
              id="id_cotizaciones_icon"
            ></i>
            <v-list-item-title>Cotizaciones</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          :value="false"
          no-action
          v-if="verCuentas()"
          color="green"
        >
          <template v-slot:activator>
            <i class="bx bx-data bx-sm icon-color" id="id_cuentas_icon"></i>
            <label for="" class="text-menu" id="id_cuentas_text">Cuentas</label>
            <!-- <v-list-item-title>Cuentas</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('cuentas-cobrar')"
            router
            to="/app/cuentas/cuentas-por-cobrar"
            class="items-menu"
          >
            <i
              class="bx bx-bookmark-alt-plus bx-sm icon-menu icon-color"
              id="id_cuentas_por_cobrar_icon"
            ></i>
            <v-list-item-title>Cuentas por cobrar</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('cuentas-pagar')"
            router
            to="/app/cuentas/cuentas-por-pagar"
            class="items-menu"
          >
            <i
              class="bx bx-bookmark-alt-minus bx-sm icon-menu icon-color"
              id="id_cuentas_por_pagar_icon"
            ></i>
            <v-list-item-title>Cuentas por pagar</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="false" no-action v-if="verCaja()" color="green">
          <template v-slot:activator>
            <i
              class="bx bx-cart-download bx-sm icon-color"
              id="id_caja_icon"
            ></i>
            <label for="" class="text-menu" id="id_caja_text">Caja</label>
            <!-- <v-list-item-title>Caja</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('cajas')"
            router
            to="/app/cajas/cajas-registradoras"
            class="items-menu"
          >
            <i
              class="bx bx-cart-add bx-sm icon-menu icon-color"
              id="id_cajas_registradoras_icon"
            ></i>
            <v-list-item-title>Cajas Registradas</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('movimientos')"
            router
            to="/app/cajas/movimientos"
            class="items-menu"
          >
            <i
              class="bx bx-git-compare bx-sm icon-menu icon-color"
              id="id_movimientos_icon"
            ></i>
            <v-list-item-title>Movimientos</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- <v-list-group
          :value="false"
          no-action
          v-if="verPlanilla()"
          color="green"
        >
          <template v-slot:activator>
            <i
              class="bx bx-spreadsheet bx-sm icon-color"
              id="id_planilla_icon"
            ></i>
            <label for="" class="text-menu" id="id_planilla_text"
              >Planilla</label
            >

          </template>
          <v-list-item
            v-if="this.$hasMenu('recibos-honorarios')"
            router
            to="/app/planillas/Honorarios"
            class="items-menu"
          >
            <i
              class="bx bx-receipt bx-sm icon-menu icon-color"
              id="id_honorarios_icon"
            ></i>
            <v-list-item-title>Recibo por Honorarios</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('planillas')"
            router
            to="/app/planillas/planillas-Info"
            class="items-menu"
          >
            <i
              class="bx bx-spreadsheet bx-sm icon-menu icon-color"
              id="id_planillas_info_icon"
            ></i>
            <v-list-item-title>Planillas</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('bonos')"
            router
            to="/app/planillas/bonos"
            class="items-menu"
          >
            <i
              class="bx bx-dollar-circle bx-sm icon-menu icon-color"
              id="id_bonos_icon"
            ></i>
            <v-list-item-title>Bonos</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('regimenes')"
            router
            to="/app/planillas/Regimen"
            class="items-menu"
          >
            <i
              class="bx bx-shield-plus bx-sm icon-menu icon-color"
              id="id_regimen_icon"
            ></i>
            <v-list-item-title>Régimen de Pensiones</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('seguros')"
            router
            to="/app/planillas/Seguros"
            class="items-menu"
          >
            <i
              class="bx bx-first-aid bx-sm icon-menu icon-color"
              id="id_seguros_icon"
            ></i>
            <v-list-item-title>Sistema de Salud</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('puestos')"
            router
            to="/app/planillas/Puestos"
            class="items-menu"
          >
            <i
              class="bx bx-store bx-sm icon-menu icon-color"
              id="id_puestos_icon"
            ></i>
            <v-list-item-title>Puestos</v-list-item-title>
          </v-list-item>
        </v-list-group> -->

        <v-list-group
          :value="false"
          no-action
          v-if="verSeguridad()"
          color="green"
        >
          <template v-slot:activator>
            <i
              class="bx bx-shield-alt-2 bx-sm icon-color"
              id="id_seguridad_icon"
            ></i>
            <label for="" class="text-menu" id="id_seguridad_text"
              >Seguridad</label
            >
            <!-- <v-list-item-title>Seguridad</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('empleados')"
            router
            to="/app/seguridad/empleados"
            class="items-menu"
          >
            <i
              class="bx bx-user-plus bx-sm icon-menu icon-color"
              id="id_empleados_icon"
            ></i>
            <v-list-item-title>Usuarios</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('roles')"
            router
            to="/app/seguridad/roles"
            class="items-menu"
          >
            <i
              class="bx bx-group bx-sm icon-menu icon-color"
              id="id_roles_icon"
            ></i>
            <v-list-item-title>Roles de usuarios</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group
          :value="false"
          no-action
          v-if="verReportes()"
          color="green"
        >
          <template v-slot:activator>
            <i class="bx bx-receipt bx-sm icon-color" id="id_reporte_icon"></i>
            <label for="" class="text-menu" id="id_reporte_text"
              >Reportes</label
            >
            <!-- <v-list-item-title>Reportes</v-list-item-title> -->
          </template>
          <v-list-item
            v-if="this.$hasMenu('reporte-purchases')"
            router
            to="/app/reportes/reporte-compras"
            class="items-menu"
          >
            <i
              class="bx bx-money-withdraw bx-sm icon-menu icon-color"
              id="id_reporte_compras_icon"
            ></i>
            <v-list-item-title>Compras</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('reporte-sales')"
            router
            to="/app/reportes/reporte-ventas"
            class="items-menu"
          >
            <i
              class="bx bx-line-chart bx-sm icon-menu icon-color"
              id="id_reporte_ventas_icon"
            ></i>
            <v-list-item-title>Ventas</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('reporte-salesCard')"
            router
            to="/app/reportes/reporte-ventas-tarjeta"
            class="items-menu"
          >
            <i
              class="bx bx-shopping-bag bx-sm icon-menu icon-color"
              id="id_reporte_ventas_tarjeta_icon"
            ></i>
            <v-list-item-title>Ventas con tarjeta</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('reporte-history-box')"
            router
            to="/app/reportes/reporte-caja"
            class="items-menu"
          >
            <i
              class="bx bx-history bx-sm icon-menu icon-color"
              id="id_reporte_caja_icon"
            ></i>
            <v-list-item-title>Historial de cajas</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$hasMenu('reporte-transferr')"
            router
            to="/app/reportes/reporte-transferencias"
            class="items-menu"
          >
            <i
              class="bx bx-send bx-sm icon-menu icon-color"
              id="id_reporte_transferencia_icon"
            ></i>
            <v-list-item-title>Transferencias</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('reporte-convenio')"
            router
            to="/app/reportes/reporte-convenio"
            class="items-menu"
          >
            <i
              class="bx bx-send bx-sm icon-menu icon-color"
              id="id_reporte_transferencia_icon"
            ></i>
            <v-list-item-title>Convenio</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('reporte-nota-credito')"
            router
            to="/app/reportes/reporte-notas-credito"
            class="items-menu"
          >
            <i
              class="bx bx-send bx-sm icon-menu icon-color"
              id="id_reporte_transferencia_icon"
            ></i>
            <v-list-item-title>Nota de Credito</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$hasMenu('reporte-consumo-interno')"
            router
            to="/app/reportes/consumo-interno"
            class="items-menu"
          >
            <i
              class="bx bx-detail bx-sm icon-menu icon-color"
              id="id_consumo_interno_icon"
            ></i>
            <v-list-item-title>Consumo Interno</v-list-item-title>
          </v-list-item>

          <!-- <v-list-item  v-if="this.$hasMenu('sesiones-vendedores')"  router to="/app/reportes/sesiones-usuario" class="items-menu">
            <i class="bx bx-detail bx-sm icon-menu icon-color" id="id_consumo_interno_icon"></i>
            <v-list-item-title>Sesiones de Vendedores</v-list-item-title>
          </v-list-item> -->

          <v-list-item
            v-if="this.$hasMenu('reporte-merma')"
            router
            to="/app/reportes/merma"
            class="items-menu"
          >
            <i
              class="bx bx-line-chart-down bx-sm icon-menu icon-color"
              id="id_merma_icon"
            ></i>
            <v-list-item-title>Merma</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item
            v-if="this.$hasMenu('reporte-productos-vendidos')"
            router
            to="/app/reportes/productos-vendidos"
            class="items-menu"
          >
            <i
              class="bx bx-purchase-tag-alt bx-sm icon-menu icon-color"
              id="id_productos_vendidos_icon"
            ></i>
            <v-list-item-title>Productos Vendidos</v-list-item-title>
          </v-list-item> -->
          <v-list-item
            v-if="this.$hasMenu('reporte-services-atendidos')"
            router
            to="/app/reportes/servicios-atendidos"
            class="items-menu"
          >
            <i
              class="bx bx-star bx-sm icon-menu icon-color"
              id="id_servicios_atendidos_icon"
            ></i>
            <v-list-item-title>Servicios Atendidos</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <div
          :class="mini ? 'mini-class' : ''"
          style="
            display: flex;
            justify-content: space-around;
            padding: 4px 10px 14px 10px;
          "
        >
          <v-btn fab dark small color="red" @click="handleLogout">
            <v-icon size="16">fas fa-sign-out-alt</v-icon>
          </v-btn>
          <v-btn
            v-if="locked"
            fab
            dark
            small
            color="green"
            @click="handleUnLockSystem"
          >
            <v-icon size="16">fas fa-lock-open</v-icon>
          </v-btn>
          <v-btn v-else fab dark small color="amber" @click="handleLockSystem">
            <v-icon size="16">fas fa-lock</v-icon>
          </v-btn>
          <v-btn
            v-if="user_offices.length > 1"
            fab
            dark
            small
            color="blue"
            @click="handleChangeOfficeLogin"
          >
            <v-icon size="16">fas fa-exchange-alt</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-content class="main-content">
      <!-- <div style="position: absolute">
        <i class="bx bx-menu bx-sm"></i>
      </div> -->
      <router-view></router-view>
    </v-content>

    <Locked ref="locked"></Locked>
    <notification-success></notification-success>
    <select-office ref="selectOffice"></select-office>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Locked from "../components/auth/Locked";
import NotificationSuccess from "../components/notifications/NotificationSuccess";
import SelectOffice from "../components/auth/SelectOffice";
import { cancelRequest } from "../apis/Api";

export default {
  name: "MainLayout",
  components: {
    Locked,
    NotificationSuccess,
    SelectOffice,
  },
  data() {
    return {
      data: [
        {
          id: 1,
          id_html: "id_configuracion_icon",
          id_html_text: "id_configuracion_text",
          active: false,
          route: "configuracion",
          detail: [
            {
              id: 1,
              id_html: "id_sucursales_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "sucursales",
            },
            {
              id: 2,
              id_html: "id_comprobantes_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "comprobantes",
            },
            {
              id: 3,
              id_html: "id_cuentas_bancarias_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "cuentas-bancarias",
            },
          ],
        },
        {
          id: 2,
          id_html: "id_registros_icon",
          id_html_text: "id_registros_text",
          active: false,
          route: "registros",
          detail: [
            {
              id: 1,
              id_html: "id_categorias_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "categorias",
            },
            {
              id: 2,
              id_html: "id_marcas_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "marcas",
            },
            {
              id: 3,
              id_html: "id_unidades_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "unidades",
            },
            {
              id: 4,
              id_html: "id_zonas_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "zonas",
            },
          ],
        },
        {
          id: 3,
          id_html: "id_logistica_icon",
          id_html_text: "id_logistica_text",
          active: false,
          route: "logistica",
          detail: [
            {
              id: 1,
              id_html: "id_proveedores_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "proveedores",
            },
            {
              id: 2,
              id_html: "id_compras_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "compras",
            },
            {
              id: 3,
              id_html: "id_almacenes_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "almacenes",
            },
            {
              id: 4,
              id_html: "id_almacenesReactivos_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "almacenesReactivos",
            },
            {
              id: 5,
              id_html: "id_transferencias_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "transferencias",
            },
          ],
        },
        {
          id: 4,
          id_html: "id_laboratorio_icon",
          id_html_text: "id_laboratorio_text",
          active: false,
          route: "laboratorio",
          detail: [
            {
              id: 1,
              id_html: "id_especialidad_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "especialidad",
            },
            {
              id: 2,
              id_html: "id_material_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "material",
            },
            {
              id: 3,
              id_html: "id_reactive_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "reactive",
            },
            {
              id: 4,
              id_html: "id_analisis_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "analisis",
            },
            {
              id: 5,
              id_html: "id_procesamiento_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "procesamiento",
            },
            {
              id: 6,
              id_html: "id_report_informar_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "report",
            },
          ],
        },
        {
          id: 5,
          id_html: "id_tesoreria_icon",
          id_html_text: "id_tesoreria_text",
          active: false,
          route: "tesoreria",
          detail: [
            {
              id: 1,
              id_html: "id_comisionMedicos_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "comisionMedicos",
            },
          ],
        },
        {
          id: 6,
          id_html: "id_ventas_icon",
          id_html_text: "id_ventas_text",
          active: false,
          route: "ventas",
          detail: [
            {
              id: 1,
              id_html: "id_clientes_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "clientes",
            },
            {
              id: 2,
              id_html: "id_pacientes_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "pacientes",
            },
            {
              id: 3,
              id_html: "id_doctores_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "doctores",
            },
            {
              id: 4,
              id_html: "id_empresas_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "empresas",
            },
            {
              id: 5,
              id_html: "id_solicitud_analisis_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "solicitud-analisis",
            },
            {
              id: 6,
              id_html: "id_cotizaciones_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "cotizaciones",
            },
          ],
        },
        {
          id: 7,
          id_html: "id_cuentas_icon",
          id_html_text: "id_cuentas_text",
          active: false,
          route: "cuentas",
          detail: [
            {
              id: 1,
              id_html: "id_cuentas_por_cobrar_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "cuentas-por-cobrar",
            },
            {
              id: 2,
              id_html: "id_cuentas_por_pagar_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "cuentas-por-pagar",
            },
          ],
        },
        {
          id: 8,
          id_html: "id_caja_icon",
          id_html_text: "id_caja_text",
          active: false,
          route: "cajas",
          detail: [
            {
              id: 1,
              id_html: "id_cajas_registradoras_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "cajas-registradoras",
            },
            {
              id: 2,
              id_html: "id_movimientos_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "movimientos",
            },
          ],
        },
        {
          id: 9,
          id_html: "id_planilla_icon",
          id_html_text: "id_planilla_text",
          active: false,
          route: "planillas",
          detail: [
            {
              id: 1,
              id_html: "id_honorarios_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "Honorarios",
            },
            {
              id: 2,
              id_html: "id_planillas_info_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "planillas-Info",
            },
            {
              id: 3,
              id_html: "id_bonos_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "bonos",
            },
            {
              id: 4,
              id_html: "id_regimen_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "Regimen",
            },
            {
              id: 5,
              id_html: "id_seguros_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "Seguros",
            },
            {
              id: 6,
              id_html: "id_puestos_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "Puestos",
            },
          ],
        },
        {
          id: 10,
          id_html: "id_seguridad_icon",
          id_html_text: "id_seguridad_text",
          active: false,
          route: "seguridad",
          detail: [
            {
              id: 1,
              id_html: "id_empleados_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "empleados",
            },
            {
              id: 2,
              id_html: "id_roles_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "roles",
            },
          ],
        },
        {
          id: 11,
          id_html: "id_reporte_icon",
          id_html_text: "id_reporte_text",
          active: false,
          route: "reportes",
          detail: [
            {
              id: 1,
              id_html: "id_reporte_compras_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "reporte-compras",
            },
            {
              id: 2,
              id_html: "id_reporte_ventas_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "reporte-ventas",
            },
            {
              id: 3,
              id_html: "id_reporte_ventas_tarjeta_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "reporte-ventas-tarjeta",
            },
            {
              id: 4,
              id_html: "id_reporte_caja_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "reporte-caja",
            },
            {
              id: 5,
              id_html: "id_reporte_transferencia_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "reporte-transferencias",
            },
            {
              id: 6,
              id_html: "id_consumo_interno_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "consumo-interno",
            },
            {
              id: 7,
              id_html: "id_merma_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "merma",
            },
            {
              id: 8,
              id_html: "id_productos_vendidos_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "productos-vendidos",
            },
            {
              id: 9,
              id_html: "id_servicios_atendidos_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "servicios-atendidos",
            },
            {
              id: 10,
              id_html: "id_servicios_atendidos_icon",
              id_html_text: "id_configuracion_text",
              active: false,
              route: "reporte-convenio",
            },
          ],
        },
      ],
      mini: false,
    };
  },
  computed: {
    ...mapState("authentication", [
      "show_menu",
      "token",
      "select_office",
      "locked",
      "user_offices",
      "set_office_id",
      "set_auth_user",
      "auth_user",
      "office_id",
    ]),
  },
  watch: {
    $route(to, from) {
      // console.log(window.location.href);
      // console.log(this.$route.path);
      // console.log(this.$route.params);
      cancelRequest();
      this.data = this.data.map((item) => {
        item.action = this.$route.path.includes(item.route);
        if (item.detail.length > 0) {
          item.detail = item.detail.map((subItem) => {
            subItem.action = this.$route.path.includes(subItem.route);
            return subItem;
          });
        }
        return item;
      });

      this.data.map((item) => {
        const elemento = document.getElementById(item.id_html);
        const elemento_text = document.getElementById(item.id_html_text);
        if (item.action) {
          elemento && elemento.classList.add("active");
          elemento_text && elemento_text.classList.add("active");
        } else {
          elemento && elemento.classList.remove("active");
          elemento_text && elemento_text.classList.remove("active");
        }

        item.detail.map((subItem) => {
          // if (subItem.route == "pacientes") {
          //   console.log(subItem);
          //   const ele = document.getElementById(subItem.id_html);
          // }
          const elementChildren = document.getElementById(subItem.id_html);
          if (subItem.action) {
            elementChildren && elementChildren.classList.add("active");
          } else {
            elementChildren && elementChildren.classList.remove("active");
          }
        });
      });
      // this.selectMenuForHover(this.$route.path);
    },
  },
  methods: {
    ...mapActions("authentication", [
      "logout",
      "run_set_locked",
      "lockSystem",
      "setShowMenu",
    ]),
    ...mapActions("purchases", ["clean_data", "setPurchaseDetail"]),
    handleChangeViewMenu(value) {
      this.setShowMenu(value);
    },
    handleChangeViewMenuChange(value) {
      console.log("======>>>>> ::::", value);
    },
    selectMenu() {
      console.log("seleccionar menu");
    },
    selectPurchase() {
      this.clean_data();
      this.setPurchaseDetail([]);
    },
    handleLogout() {
      this.logout();
    },
    handleLockSystem() {
      this.run_set_locked(true);
      this.$refs.locked.show();
      //await this.lockSystem();
    },
    handleUnLockSystem() {
      this.run_set_locked(false);
    },
    verDashboard() {
      return (
        this.$hasMenu("dashboard-analisis") ||
        this.$hasMenu("dashboard-medico") ||
        this.$hasMenu("dashboard-paciente") ||
        this.$hasMenu("dashboard-convenio") ||
        this.$hasMenu("dashboard-sales")
      );
    },
    verConfiguracion() {
      return (
        // this.$hasMenu("companies") ||
        this.$hasMenu("sedes") ||
        this.$hasMenu("sucursales") ||
        this.$hasMenu("comprobantes") ||
        this.$hasMenu("cuentas-bancarias")
      );
    },
    verRegistros() {
      return (
        this.$hasMenu("categorias") ||
        this.$hasMenu("capacidades") ||
        this.$hasMenu("colores") ||
        this.$hasMenu("marcas") ||
        this.$hasMenu("tipos") ||
        this.$hasMenu("unidades")
      );
    },
    verLogistica() {
      return (
        this.$hasMenu("proveedores") ||
        this.$hasMenu("servicios") ||
        this.$hasMenu("compras") ||
        this.$hasMenu("almacenes") ||
        this.$hasMenu("almacenesReactivos") ||
        this.$hasMenu("transferencias") ||
        this.$hasMenu("areas")
      );
    },
    verNewLab() {
      return (
        this.$hasMenu("especialidad") ||
        this.$hasMenu("material") ||
        this.$hasMenu("reactivos") ||
        this.$hasMenu("analisis") ||
        this.$hasMenu("procesamiento") ||
        this.$hasMenu("laboratorio-informar")
      );
    },
    verTesoreria() {
      return (
        this.$hasMenu("comisiones-medicos") ||
        this.$hasMenu("comision-empresas") ||
        this.$hasMenu("categoria-gastos") ||
        this.$hasMenu("gastos")
      );
    },
    verVentas() {
      return (
        this.$hasMenu("clientes") ||
        this.$hasMenu("pacientes") ||
        this.$hasMenu("doctores") ||
        this.$hasMenu("companies") ||
        this.$hasMenu("nuevo-pedido") ||
        this.$hasMenu("pedidos") ||
        this.$hasMenu("solicitud-analisis") ||
        this.$hasMenu("cotizaciones")
      );
    },
    verCaja() {
      return this.$hasMenu("cajas") || this.$hasMenu("movimientos");
    },
    verComisiones() {
      return (
        this.$hasMenu("procesar-comisiones") ||
        this.$hasMenu("comisiones-procesadas")
      );
    },
    verSeguridad() {
      return this.$hasMenu("empleados") || this.$hasMenu("roles");
    },
    verPlanilla() {
      return (
        this.$hasMenu("planillas") ||
        this.$hasMenu("recibos-honorarios") ||
        this.$hasMenu("bonos") ||
        this.$hasMenu("regimenes") ||
        this.$hasMenu("seguros") ||
        this.$hasMenu("puestos")
      );
    },
    verReportes() {
      return (
        this.$hasMenu("reporte-purchases") ||
        this.$hasMenu("reporte-sales") ||
        this.$hasMenu("reporte-salesCard") ||
        this.$hasMenu("reporte-transferr") ||
        this.$hasMenu("reporte-history-box") ||
        this.$hasMenu("reporte-nota-credito") ||
        this.$hasMenu("sesiones-vendedores") ||
        this.$hasMenu("reporte-consumo-interno") ||
        this.$hasMenu("reporte-merma") ||
        this.$hasMenu("reporte-productos-vendidos") ||
        this.$hasMenu("reporte-convenio") ||
        this.$hasMenu("reporte-services-atendidos")
      );
    },
    verLaboratorio() {
      return this.$hasMenu("laboratory");
    },
    verCuentas() {
      return this.$hasMenu("cuentas-cobrar") || this.$hasMenu("cuentas-pagar");
    },
    handleChangeOfficeLogin() {
      this.$refs.selectOffice.show();
    },
    selectMenuForHover(path) {
      this.data = this.data.map((item) => {
        item.action = path.includes(item.route);
        return item;
      });
      this.data.map((item) => {
        const elemento = document.getElementById(item.id_html);
        if (item.action) {
          elemento.classList.add("active");
        } else {
          elemento.classList.remove("active");
        }
      });
    },
    $routexd(to, from) {
      this.data = this.data.map((item) => {
        item.action = this.$route.path.includes(item.route);
        if (item.detail.length > 0) {
          item.detail = item.detail.map((subItem) => {
            subItem.action = this.$route.path.includes(subItem.route);
            return subItem;
          });
        }
        return item;
      });

      this.data.map((item) => {
        const elemento = document.getElementById(item.id_html);
        const elemento_text = document.getElementById(item.id_html_text);
        if (item.action) {
          elemento && elemento.classList.add("active");
          elemento_text && elemento_text.classList.add("active");
        } else {
          elemento && elemento.classList.remove("active");
          elemento_text && elemento_text.classList.remove("active");
        }

        item.detail.map((subItem) => {
          // if (subItem.route == "pacientes") {
          //   console.log(subItem);
          //   const ele = document.getElementById(subItem.id_html);
          // }
          const elementChildren = document.getElementById(subItem.id_html);
          if (subItem.action) {
            elementChildren && elementChildren.classList.add("active");
          } else {
            elementChildren && elementChildren.classList.remove("active");
          }
        });
      });
    },
  },
  mounted() {
    this.$routexd();
  },
};
</script>

<style>
/* .v-list-group {
  background-color: green;
  color: green;
} */

.v-list-item__icon {
  justify-content: end !important;
  width: 100% !important;
}

.items-menu {
  padding-left: 30px !important;
  text-align: start;
}

.btn-navbar {
  width: 100% !important;
  border-radius: 8px !important;
  padding: 0 5px 0 4px;
  color: #666666 !important;
}

.mini-class {
  flex-direction: column;
  row-gap: 0.5rem;
}

.icon-color {
  color: #666666;
}

.text-menu {
  cursor: pointer;
  margin-left: 6px;
  align-items: start !important;
  color: #666666;
}

.btn-active:hover {
  background-color: #05f70069 !important;
  color: #59a83d !important;
}

.active {
  /* background-color: #05f70069 !important; */
  color: #59a83d !important;
}

.border {
  border-left: 4px solid #616161;
}

.icon-menu {
  margin-right: 5px !important;
}

.sub-menu {
  margin-left: 30px;
  margin-right: 0px;
}

.w-item-menu {
  padding: 0 3px !important;
}

.main-content {
  text-align: left !important;
  background-color: #f4f6f8;
}

.list-menu {
  text-align: center;
}

.dial-logout {
  right: 2px !important;
  bottom: 5px !important;
}

.sub-menu {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  margin-block: 19px;
  background-color: white;
  margin-bottom: 10px;
  cursor: pointer;
}

.btn-logout {
  height: 40px !important;
  width: 40px !important;
}

.fa-cogs path {
  stroke: rgb(255, 0, 0);
  stroke-width: 30px;
}
</style>
